import { render, staticRenderFns } from "./vnCamelPay.vue?vue&type=template&id=70f44f1a&scoped=true"
import script from "./vnCamelPay.vue?vue&type=script&lang=js"
export * from "./vnCamelPay.vue?vue&type=script&lang=js"
import style0 from "./vnCamelPay.vue?vue&type=style&index=0&id=70f44f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f44f1a",
  null
  
)

export default component.exports